import React from 'react'
import styles from './BackButton.module.css'
import { BackButtonProps } from './types'
import { useStepContext } from '../../../Context/StepContext'

export const BackButton: React.FC<BackButtonProps> = ({
    dataClickLabel,
    onClick
}) => {
    const { handlePrev } = useStepContext()

    const handleClick = () => {
        if (onClick) {
            onClick()
        } else {
            handlePrev()
        }
    }

    return (
        <button
            className={styles.content}
            onClick={handleClick}
            data-click-label={dataClickLabel}
            type='button'
        >
            <img
                src={'/entry_form_slide_app/common/previewIcon.png'}
                alt={'バックボタンアイコン'}
            />
        </button>
    )
}
